module.exports = "images/doc-activity-add-2.9aa30794274cafeb4d74ea3b4c458c61.png";